//Polyfill Promise for ie
require('es6-promise/auto');
import _ from 'lodash';
import fetch from 'isomorphic-fetch';
import thunkMiddleware from 'redux-thunk';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import React from 'react';
import { createStore, applyMiddleware, compose } from 'redux';
import watch from 'redux-watch';
import reducer from './reducers';
import { addFilterOption } from './actions/filter-options';
import { toggleFilter, setFilter } from './actions/filter';
import { fetchPosts, setStaticHtml, setTotalPages } from './actions/posts';
import Config from './config';
import ResourceGridApp from './components/resource-grid';

let store = createStore(reducer, compose(
	applyMiddleware(thunkMiddleware),
	window.devToolsExtension ? window.devToolsExtension() : f => f
));

let el = document.getElementById(Config.elementId);

if(el){
	store.dispatch(setStaticHtml(el.querySelector('.blog-posts .container').innerHTML));
	Config.ebookContent = el.querySelector('.blog-ebook-cta');
	let autoFilter;

	if(el.hasAttribute('data-filter') && el.getAttribute('data-filter')){
		try{
			autoFilter = JSON.parse(el.getAttribute('data-filter'));
		} catch (err) {
			console.warn(err);
		}
	}

	if(el.hasAttribute('data-total-pages') && el.getAttribute('data-total-pages')){
		store.dispatch(setTotalPages(el.getAttribute('data-total-pages')));
	}

	render(
		<Provider store={store}>
			<ResourceGridApp />
		</Provider>,
		el
	);

	// First, grab all taxonomies on the post type...
	fetch(`${_.result(window, 'SiteInfo.homeUrl', '')}/wp-json/wp/v2/taxonomies`)
		//and convert those to an object
		.then(response => response.json())
		//then with those taxonomies...
		.then(json => {
			//Get the list of taxonomies we want to display on the grid...
			let gridTaxonomies = Config.filterTaxonomies.map(t => t.key);

			//Then the grab api endpoints for whichever terms are in that list
			let termEndpoints = _(json)
				.filter(t => gridTaxonomies.includes(t.slug))
				.map(t => _.result(t, '_links.wp:items[0].href'))
				.value();

			//Now promise to load all that shit.
			return Promise.all(termEndpoints.map(e => {
				return fetch(e + '?per_page=100').then(r => r.json());
			}));
		})
		//Then add the filter for each of those taxonomies
		.then(taxonomyTerms => {
			for(let index in taxonomyTerms){
				let terms = taxonomyTerms[index];
				if(terms.length > 0){
					let slug = _.result(terms, '[0].taxonomy', '');
					let termTaxonomy = _.find(Config.filterTaxonomies, t => t.key === slug);
					let name = _.result(termTaxonomy, 'label', '');
					let instructions = _.result(termTaxonomy, 'instructions', '');

					store.dispatch(addFilterOption(slug, name, instructions, terms));
				}
			}
		})
		//If any filters should be on by default, do that
		.then(() => {
			let filterOptions = store.getState().filterOptions;

			for(let filterKey in autoFilter){
				let filterValue = autoFilter[filterKey];
				let filterMenu = _.find(filterOptions, ['name', filterKey]);
				let filterOption = _.find(filterMenu.options, ['slug', filterValue]);
				store.dispatch(toggleFilter(filterKey, filterOption));
			}
		})
		//Or if we have a hash, that will override the filter
		.then(() => {
			if(window.location.hash){
				store.dispatch(setFilter(hashToFilter()));
				store.dispatch(fetchPosts());
			}
		})
		//Watch for any filter changes
		.then(() => {
			let filterWatch = watch(store.getState, 'filter')
			store.subscribe(filterWatch((newFilter) => {
				window.location.hash = filterToHash(newFilter);
			}))
		})
		.then(() => {
			window.addEventListener('hashchange', function(e){
				e.preventDefault();
				if(window.location.hash.substr(1) !== filterToHash(store.getState().filter)){
					store.dispatch(setFilter(hashToFilter()));
				}

				store.dispatch(fetchPosts());
			}, false);
		});
}

const filterToHash = filter => {
	let ret = [];
	let hash = {};

	for(var key in filter){
		let val = filter[key];

		switch(key){
			case 'page':
			case 'text':
				hash[key] = val;
				break;

			default:
				if(val && val.length > 0){
					hash[key] = val.map(t => t.slug).join(',');
				}
		}
	}

	for(key in hash){
		ret.push(encodeURIComponent(key) + '=' + encodeURIComponent(hash[key]));
	}

	return ret.join('/');
}

const hashToFilter = () => {
	let hash = window.location.hash.substr(1);
	let ret = {};
	let filterOptions = store.getState().filterOptions;
	let keyValPairs = hash.split('/');

	for(var index in keyValPairs){
		var splitPair, key, val;
		splitPair = keyValPairs[index].split('=');
		key = decodeURIComponent(splitPair[0]);
		val = decodeURIComponent(splitPair[1]);

		switch(key){
			case 'page':
				ret[key] = parseInt(val, 10);
				break;

			case 'text':
				ret[key] = val;
				break;

			default:
				let slugs = val.split(',');
				let filterMenu = _.find(filterOptions, ['name', key]);
				let terms = slugs.map(slug => _.find(filterMenu.options, ['slug', slug]));
				if(terms.length > 0){
					ret[key] = terms;
				}
		}
	}

	return ret;
}



// WEBPACK FOOTER //
// ./wp-content/themes/stanleyelevator/assets/scripts/source/blog-grid/index.js